







































































import { computed, defineComponent, PropType } from '@vue/composition-api';
import moment from 'moment';
import { IBank } from '@/models';

import BankOptionsButton from './BankOptionsButton.vue';
import PaymentInstructionList from './PaymentInstructionList.vue';

export default defineComponent({
  name: 'BankDrawer',
  components: { BankOptionsButton, PaymentInstructionList },
  props: {
    drawer: {
      type: Boolean,
      required: true
    },
    bank: {
      type: Object as PropType<IBank | null>,
      default: null
    }
  },
  emits: ['update:drawer'],
  setup(props, { emit }) {
    const localDrawer = computed({
      get: () => props.drawer,
      set: value => {
        emit('update:drawer', value);
      }
    });

    return {
      localDrawer,
      moment
    };
  }
});
